module.exports = __webpack_public_path__ + "static/media/intro.9c5add1b.mp3";